import { contato, sobre } from '../data/conteudo';
import styles from './Sobre.module.css';

const Sobre = () => (
  <section id="sobre" className="secao" aria-labelledby="titulo-sobre">
    <div className={`container ${styles.grade}`}>
      <div className={styles.texto}>
        <h2 id="titulo-sobre">Sobre mim</h2>
        <p className={styles.nomeCompleto}>{contato.nomeCompleto}</p>
        {sobre.paragrafos.map((paragrafo) => (
          <p key={paragrafo.slice(0, 24)}>{paragrafo}</p>
        ))}
      </div>

      <aside className={styles.formacao} aria-labelledby="titulo-formacao">
        <h3 id="titulo-formacao">Formação e atuação</h3>
        <ul>
          {sobre.formacao.map((item) => (
            <li key={item.titulo}>
              <strong>{item.titulo}</strong>
              {item.detalhe && <span>{item.detalhe}</span>}
            </li>
          ))}
        </ul>
      </aside>

      <figure className={styles.citacao}>
        <blockquote>
          <p>“{sobre.citacao.texto}”</p>
        </blockquote>
        <figcaption>{sobre.citacao.autor}</figcaption>
      </figure>
    </div>
  </section>
);

export default Sobre;
